import { useQuery } from '@tanstack/vue-query'
import type { UserInvite } from '@tapp.online/auth/runtime/types/index.js'

/** The signed-in user's open invites to other workspaces. */
export const usePendingInvites = () => {
    const { apiFetch } = useAuthFetch()
    const { isAuthenticated } = useAuth()

    const { data } = useQuery({
        queryKey: ['userTokens', 'me'],
        queryFn: async () => {
            const response = await apiFetch<{ data?: UserInvite[] } | UserInvite[]>('/userTokens/me?filter=type[eq]userInvite')
            return Array.isArray(response) ? response : (response?.data ?? [])
        },
        enabled: isAuthenticated
    })

    const pendingInvites = computed(() => data.value ?? [])

    return { pendingInvites }
}
